import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a2db382a")

_pushScopeId("data-v-a2db382a")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: " p-grid p-m-0 kn-page-content" }
const _hoisted_3 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 kn-list" }
const _hoisted_4 = { class: "p-d-flex p-flex-column p-m-3" }
const _hoisted_5 = {
  key: 0,
  for: "glossary",
  class: "kn-material-input-label"
}
const _hoisted_6 = {
  key: 0,
  "data-test": "no-glossary-found-hint"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "p-m-3" }
const _hoisted_9 = { class: "p-ml-2" }
const _hoisted_10 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")
  const _component_GlossaryUsageInfoDialog = _resolveComponent("GlossaryUsageInfoDialog")
  const _component_GlossaryUsageHint = _resolveComponent("GlossaryUsageHint")
  const _component_GlossaryUsageDetail = _resolveComponent("GlossaryUsageDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.title')), 1)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          (_ctx.selectedGlossaryId)
            ? (_openBlock(), _createBlock("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.title')), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_Dropdown, {
            id: "glossary",
            class: "kn-material-input",
            modelValue: _ctx.selectedGlossaryId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedGlossaryId = $event)),
            options: _ctx.glossaryList,
            optionLabel: "GLOSSARY_NM",
            optionValue: "GLOSSARY_ID",
            placeholder: _ctx.$t('managers.glossary.glossaryUsage.selectGlossary')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        _createVNode("div", null, [
          (_ctx.glossaryList.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1))
            : (!_ctx.selectedGlossaryId)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 1,
                  class: "p-mx-3",
                  "data-test": "no-glossary-selected-tree-hint"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.glossaryHint')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_InputText, {
                      id: "search-input",
                      class: "kn-material-input",
                      modelValue: _ctx.searchWord,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchWord = $event)),
                      placeholder: _ctx.$t('common.search'),
                      onInput: _ctx.filterGlossaryTree,
                      "data-test": "search-input"
                    }, null, 8, ["modelValue", "placeholder", "onInput"])
                  ]),
                  (!_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_Tree, {
                        key: 0,
                        id: "glossary-tree",
                        value: _ctx.nodes,
                        selectionMode: "multiple",
                        selectionKeys: _ctx.selectedKeys,
                        "onUpdate:selectionKeys": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedKeys = $event)),
                        metaKeySelection: false,
                        expandedKeys: _ctx.expandedKeys,
                        onNodeExpand: _cache[4] || (_cache[4] = ($event: any) => (_ctx.listContents(_ctx.selectedGlossaryId, $event))),
                        onNodeSelect: _ctx.onNodeSelect,
                        onNodeUnselect: _ctx.onNodeUnselect,
                        "data-test": "glossary-tree"
                      }, {
                        default: _withId((slotProps) => [
                          _createVNode("div", {
                            class: "p-d-flex p-flex-row p-ai-center",
                            onMouseover: ($event: any) => (_ctx.buttonVisible[slotProps.node.id] = true),
                            onMouseleave: ($event: any) => (_ctx.buttonVisible[slotProps.node.id] = false),
                            draggable: slotProps.node.leaf,
                            onDragstart: ($event: any) => (_ctx.onDragStart($event, slotProps.node)),
                            "data-test": 'tree-item-' + slotProps.node.id
                          }, [
                            _createVNode("span", null, _toDisplayString(slotProps.node.label), 1),
                            _withDirectives(_createVNode("div", _hoisted_9, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-info-circle",
                                class: "p-button-link p-button-sm p-p-0",
                                onClick: _withModifiers(($event: any) => (_ctx.showInfo(slotProps.node.data)), ["stop"])
                              }, null, 8, ["onClick"])
                            ], 512), [
                              [_vShow, _ctx.buttonVisible[slotProps.node.id]]
                            ])
                          ], 40, ["onMouseover", "onMouseleave", "draggable", "onDragstart", "data-test"])
                        ]),
                        _: 1
                      }, 8, ["value", "selectionKeys", "expandedKeys", "onNodeSelect", "onNodeUnselect"]))
                    : _createCommentVNode("", true)
                ]))
        ])
      ]),
      _withDirectives(_createVNode(_component_GlossaryUsageInfoDialog, {
        visible: _ctx.infoDialogVisible,
        contentInfo: _ctx.contentInfo,
        selectedWords: _ctx.selectedWords,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.infoDialogVisible = false)),
        onLoading: _ctx.setLoading
      }, null, 8, ["visible", "contentInfo", "selectedWords", "onLoading"]), [
        [_vShow, _ctx.infoDialogVisible]
      ]),
      _createVNode("div", _hoisted_10, [
        (!_ctx.selectedGlossaryId)
          ? (_openBlock(), _createBlock(_component_GlossaryUsageHint, {
              key: 0,
              "data-test": "no-glossary-selected-hint"
            }))
          : (_openBlock(), _createBlock(_component_GlossaryUsageDetail, {
              key: 1,
              glossaryId: _ctx.selectedGlossaryId,
              selectedWords: _ctx.selectedWords,
              onInfoClicked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showNavigationItemInfo($event))),
              onWordsFiltered: _ctx.setFilteredWords
            }, null, 8, ["glossaryId", "selectedWords", "onWordsFiltered"]))
      ])
    ])
  ]))
})